import React from 'react';


export default function Schema({artistsRelated, artist}) {

    function getSingleRender(artistRelated) {
        return (
            <div className={"single-related"}>
                <div className={"single-related__data"}>
                    <a href={`${window.location.origin}/?page=dashboard&artist=${artistRelated.id}`} className="d-flex flex-column justify-content-center">
                        <span>{artistRelated.name}</span>
                        <u>Voir</u>
                    </a>
                </div>
                <img src={artistRelated.images[1].url} alt={`Image de ${artistRelated.name}`} className={'img-1'}/>
            </div>
        )
    }

    return (
        <div className="schema-related d-none d-xl-flex">
            <div className={"schema-related__line"}>
                {getSingleRender(artistsRelated[0])}
                {getSingleRender(artistsRelated[9])}
            </div>
            <div className={"schema-related__line"}>
                {getSingleRender(artistsRelated[1])}
                {getSingleRender(artistsRelated[8])}
            </div>
            <div className={"schema-related__line"}>
                {getSingleRender(artistsRelated[2])}
                {getSingleRender(artistsRelated[7])}
            </div>
            <div className={"schema-related__line"}>
                {getSingleRender(artistsRelated[3])}
                {getSingleRender(artistsRelated[6])}
            </div>
            <div className={"schema-related__line"}>
                {getSingleRender(artistsRelated[4])}
                {getSingleRender(artistsRelated[5])}
            </div>
            {artist.images && (
                <img src={artist.images[1].url} alt={`Image de ${artist.name}`}/>
            )}
        </div>
    )
}